export interface ITireCpkItem {
  created?: string;
  updated?: string;
  state?: string;
  status?: string;
  function?: string;
  recap?: number;
  groove?: number;
  odometer?: number;
  performance?: number;
  lifeExpectancy?: number;
  lifePercent?: number;
  cpk?: number;
  totalCost?: number;

  tire?: {
    marking?: string;
    tireModel?: {
      name?: string;
      tireManufacturer?: {
        name?: string;
      };
    };
  };
  
  tireTreadModel?: {
    name?: string;
    tireTreadManufacturer?: {
      name?: string;
    };
  };

  truckImplement?: {
    id?: number;
    name?: string;
  };

  company?: {
    id?: number;
    name?: string;
  };
}

export interface IByFunction {
  function?: string;
  lastPeriod?: number;
  allPeriod?: number;
}

export interface IByVehicleType {
  vehicleType?: string;
  lastPeriod?: number;
  allPeriod?: number;
}

export interface IByMonthFunction {
  month?: string;
  function?: string;
  avgCpk?: number;
}

export interface IByMonthVehicleType {
  month?: string;
  vehicleType?: string;
  avgCpk?: number;
}

export interface ITireCpkDashboard {
  byFunction: IByFunction[];
  byVehicleType: IByVehicleType[];
  byMonthByFunction: IByMonthFunction[];
  byMonthByVehicleType: IByMonthVehicleType[];
}

export const defaultDashboardValue: Readonly<ITireCpkDashboard> = {
  byFunction: [],
  byVehicleType: [],
  byMonthByFunction: [],
  byMonthByVehicleType: [],
};